export const pink = {
  active: 'hsla(290, 68%, 79%, 1)',
};

export type PinkPalette = typeof pink;
